import { render, staticRenderFns } from "./Dispute.vue?vue&type=template&id=556deb74&scoped=true&"
import script from "./Dispute.vue?vue&type=script&lang=js&"
export * from "./Dispute.vue?vue&type=script&lang=js&"
import style0 from "./Dispute.vue?vue&type=style&index=0&id=556deb74&lang=scss&scoped=true&"
import style1 from "./Dispute.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556deb74",
  null
  
)

export default component.exports